<template>
  <PaginationWrapper
    v-slot="{ pageSize, setPageSize, setCurrentPage, currentPage }"
    class="keyword-planner-result-list"
    @size-change="changePageSize"
    @current-change="changeCurrentPage"
  >
    <LbTable
      has-selection
      :data="data"
      :columns="columns"
      :selection="selection"
      :row-id-fn="rowIdFn"
      :clear-selection-controller="clearSelectionController"
      @update:selection="emitSelectionChanged"
    />

    <div class="keyword-planner-result-list__pagination">
      <ElPagination
        class="el-pagination--block"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total"
        @size-change="setPageSize"
        @current-change="setCurrentPage"
      />
    </div>
  </PaginationWrapper>
</template>

<script>
import pagination from '@/mixins/pagination';
import PaginationWrapper from '@@/common/paginations/PaginationWrapper';
import LbTable from '../../common/LbTable';

export default {
  name: 'KeywordPlannerResultList',
  components: {
    PaginationWrapper,
    LbTable,
  },
  mixins: [pagination],
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    selection: {
      type: Array,
      default: () => [],
    },
    clearSelectionController: {
      type: Object,
      default: () => ({ onClearSelection() {}, removeOnClearSelection() {} }),
    },
  },
  computed: {
    pageSizes() {
      return this.getPageSizes(this.total);
    },
  },
  methods: {
    emitSelectionChanged(selection) {
      this.$emit('update:selection', selection);
    },
    changePageSize(size) {
      this.$emit('change-size', size);
    },
    changeCurrentPage(page) {
      this.$emit('change-current', page);
    },
    rowIdFn({ query }) {
      return query;
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-result-list {
  overflow-x: auto;

  &__pagination {
    padding: $global-padding * 1.5 $global-padding;
  }
}
</style>
